import React from 'react';
import PropTypes from 'prop-types';

import { EmptyTabContainer, LeftSideContainer, RightSideContainer } from './ChatUIEmptyTab.styles';
import { emptyTabImgData } from 'constants/chatUI';

const propTypes = {
  title: PropTypes.string.isRequired,
  isError: PropTypes.bool,
};

const ChatUIEmptyTab = ({ title, isError }) => {
  const renderRightSideContent = () => {
    if (isError) {
      return <h4>Sorry, there was a problem trying to load this information.</h4>;
    }

    return <h4>Sorry, you have no {title.toLowerCase()} at this time.</h4>;
  };

  return (
    <EmptyTabContainer>
      <LeftSideContainer>
        <img
          src={isError ? emptyTabImgData.error.src : emptyTabImgData.empty.src}
          alt={isError ? emptyTabImgData.error.alt : emptyTabImgData.empty.alt}
        />
      </LeftSideContainer>
      <RightSideContainer>{renderRightSideContent()}</RightSideContainer>
    </EmptyTabContainer>
  );
};

ChatUIEmptyTab.propTypes = propTypes;

export default ChatUIEmptyTab;
